import React, { useContext, useState } from 'react';
import { HomepageContext } from '@components/Providers/HomepageProvider';
import { CustomerApplications } from '@components/CustomerApplications/index';
import { CUSTOMER_APPLICATIONS_STATE_CATEGORIES } from '@app/constants/applications';
import { ICON_NAMES, Select } from '@reverse-hr/design-system';
import { useTranslation } from 'react-i18next';

export const HomepageCandidates = () => {
  const { t } = useTranslation();
  const [jobId, setJobId] = useState();
  const { customerJobs } = useContext(HomepageContext);

  const jobsSelectOptions = [
    {
      value: '',
      displayValue: t('homepage.candidates.allJobs'),
    },
    ...getJobsSelectOptions(customerJobs),
  ];

  const onJobSelectChange = ({ value }) => setJobId(value || undefined);

  return (
    <div className="c-homepage-candidates rev-o-container">
      <div className="rev-o-grid rev-u-py-40">
        <div className="rev-o-col-12 rev-u-px-16">
          <div className="rev-o-container">
            <div className="rev-o-grid">
              <div className="c-homepage-candidates__jobs ">
                <span className="c-homepage-candidates__jobs-label">
                  {t('homepage.candidates.filterByJob')}
                </span>

                <Select
                  className="c-homepage-candidates__jobs-select"
                  isSmall
                  leadingIcon={ICON_NAMES.BRIEFBAG}
                  onChange={onJobSelectChange}
                  options={jobsSelectOptions}
                  value={jobId ?? ''}
                />
              </div>
            </div>

            <div className="rev-o-grid">
              <div className="rev-o-col-12">
                <CustomerApplications
                  isStateFilterAvailable
                  jobId={jobId}
                  stateCategory={CUSTOMER_APPLICATIONS_STATE_CATEGORIES.ACTIVE}
                />

                <CustomerApplications
                  jobId={jobId}
                  stateCategory={CUSTOMER_APPLICATIONS_STATE_CATEGORIES.HIRED}
                />

                <CustomerApplications
                  jobId={jobId}
                  stateCategory={CUSTOMER_APPLICATIONS_STATE_CATEGORIES.STOPPED}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const getJobsSelectOptions = customerJobs => {
  customerJobs.sort((a, b) => (a.title > b.title ? 1 : -1));

  return customerJobs.map(job => ({
    value: job.id,
    displayValue: job.title,
  }));
};
